export default __webpack_public_path__ + "static/media/2.5ff5c746.jpg";